import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 *
 * Copyright IBM Corp. 2019
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { selectorTabbable } from '../settings';
/**
 * @param Base The base class.
 * @returns A mix-in implementing `.focus()` method that focuses on the first focusable element in the shadow DOM.
 */

var FocusMixin = function FocusMixin(Base) {
  return /*#__PURE__*/function (_Base) {
    _inherits(_class, _Base);

    var _super = _createSuper(_class);

    function _class() {
      _classCallCheck(this, _class);

      return _super.apply(this, arguments);
    }

    _createClass(_class, [{
      key: "focus",
      value:
      /**
       * Focuses on the first focusable element in the shadow DOM.
       */
      function focus() {
        // @ts-ignore: Until `delegatesFocus` is added to `ShadowRoot` definition
        if (this.shadowRoot.delegatesFocus) {
          _get(_getPrototypeOf(_class.prototype), "focus", this).call(this);
        } else {
          var delegateTarget = this.shadowRoot.querySelector(selectorTabbable) || this.querySelector(selectorTabbable);

          if (delegateTarget) {
            delegateTarget.focus();
          } else {
            _get(_getPrototypeOf(_class.prototype), "focus", this).call(this);
          }
        }
      }
    }]);

    return _class;
  }(Base);
};

export default FocusMixin;